import dynamic from 'next/dynamic'
import { usePlatformTheme } from '~/context/theme'

import styles from './Footer.module.scss'

const SharedFooter = dynamic(
  () => import('@channel/shared-header-footer').then((module) => module.Footer),
  { ssr: false }
)

const WhitelabelFooter = dynamic(
  () => import('./WhitelabelFooter').then((module) => module.WhitelabelFooter),
  { ssr: false }
)

function Footer(): JSX.Element {
  const { isWhitelabel } = usePlatformTheme()
  if (isWhitelabel) {
    return <WhitelabelFooter />
  }

  return (
    <div className={styles.container}>
      <SharedFooter />
    </div>
  )
}

export default Footer
